import { render, staticRenderFns } from "./ListDesc.vue?vue&type=template&id=44aab7ac&scoped=true"
import script from "./ListDesc.vue?vue&type=script&lang=js"
export * from "./ListDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aab7ac",
  null
  
)

export default component.exports